import React, {useRef, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Form} from '@unform/web';
import * as Yup from 'yup';
import {
	Row,
	Col,
	FormGroup,
	Button,
	Label, Alert
} from 'reactstrap';
import ReactGA from 'react-ga4';
import { CiCalculator1 } from "react-icons/ci";
import Input from '~/components/Input';
import {LoaderLista} from '~/components/Loaders';
import * as ActionsAuth from '~/store/modules/auth/actions';
import history from '~/services/history';
import getValidationErrors from '~/utils/getValidationErrors';
import {Container, Box, Background, Logo, ButtonSecondary} from '../styles';

function EnvironmentAlert() {
	if (process.env.REACT_APP_ENV !== 'PRODUCTION') {
		return (
			<Alert color="danger" className="text-center">
				<strong>
					Atenção, você está acessando o ambiente:
					{process.env.REACT_APP_ENV}
				</strong>
			</Alert>
		);
	}
	return null;
}


function Login() {
	const {user} = useSelector((state) => state.auth);
	const formRef = useRef(null);
	const dispatch = useDispatch();
	const [isPageLoaded, setPageLoaded] = useState(false);

	useEffect(() => {
		const afterPageLoad = () => {
			if (window.props) {
				dispatch(ActionsAuth.requestLogin(window.props));
			}
		};

		if (document.readyState === 'complete') {
			setPageLoaded(true);
		}

		// Ouvinte pra quando a página carregar por completo
		window.addEventListener('load', () => {
			setPageLoaded(true);
		});

		if (isPageLoaded) {
			afterPageLoad();
		}
	}, [isPageLoaded]);

	function handleClickLoginPadraoGA4() {
		ReactGA.event({
			category: "login_padrao",
			action: `Login Padrão`,
			label: `Login Padrão`,
		});
	}


	const handleSubmitLogin = async (dados) => {
		const dadosTrim = {
			username: dados.username.trim(),
			password: dados.password.trim()
		}
		try {
			const schema = Yup.object().shape({
				username: Yup.string().required('O e-mail é obrigatório'),
				password: Yup.string().required('A senha é obrigatória'),
			});

			await schema.validate(dadosTrim, {
				abortEarly: false,
			});

			dispatch(ActionsAuth.requestLogin(dadosTrim));

			handleClickLoginPadraoGA4();
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errors = getValidationErrors(err);
				formRef.current.setErrors(errors);
			}
		}
	};

	function handleEsqueciSenha() {
		history.push('reset-pass');
	}

	function accessSimulador() {
		window.open(`${process.env.REACT_APP_INTEGRADOR}/simulacao-doc/`, '_blank')
	}


	function handleAcessoToken() {
		history.push('token-authentication');
	}

	return (
		<Container>
			<Background />
			<Col>
				<Box style={{padding: 20}}>
					<EnvironmentAlert />
					<Logo />

					{user.loading ? (
						<LoaderLista
							message="Entrando..."
							lista={[]}
							loading={user.loading}>
							<div />
						</LoaderLista>
					) : (
						<Form ref={formRef} onSubmit={handleSubmitLogin}>

							<FormGroup>
								<Label>
									Digite seu e-mail ou usuário
								</Label>
								<Input
									name="username"
									type="text"
									placeholder="E-mail ou usuário"
								/>
							</FormGroup>
							<FormGroup>
								<Label>Digite sua senha</Label>
								<Input
									name="password"
									type="password"
									placeholder="Senha"
								/>
							</FormGroup>
							<Row className="rowButton">
								<Col>
									<Button
										outline
										color="primary"
										className="buttonComponentOutline"
										onClick={() => handleEsqueciSenha()}>
										ESQUECI A SENHA
									</Button>
								</Col>
								<Col>
									<Button
										color="primary"
										className="buttonComponent"
										type="submit"
										disabled={user.loading}>
										ENTRAR
									</Button>
								</Col>
							</Row>
							<Row>
								<Col>
									<button type="button" className="buttonComponentToken" onClick={() => handleAcessoToken()}>
										ACESSO VIA TOKEN
									</button>
								</Col>

							</Row>
						</Form>
					)}
				</Box>

				<Box style={{padding: 15, marginTop: 5, borderRadius: '0 0 25px 25px'}}>
					<Row>
						<Col>
							<ButtonSecondary
								outline
								onClick={() => accessSimulador()}>
									<CiCalculator1 size={23} style={{marginRight: '10px'}} />
									ACESSAR SIMULADOR
							</ButtonSecondary>
						</Col>
					</Row>
				</Box>
			</Col>

		</Container>
	);
}

export default Login;
